import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Uncontacted } from './components/Uncontacted';
import { Contacted } from './components/Contacted';
import { Called } from './components/Called';
import { Other } from './components/Other';
import { Hyperlink } from '../components/Hyperlink';

type Props = {
  phoneNumber: string;
  isIcp: boolean;
  isContacted: boolean;
  hasCalled: boolean;
  onCall: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onContact: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const HomeExpired: FC<Props> = ({
  isIcp,
  onContact,
  isContacted,
  hasCalled,
  phoneNumber,
  onCall,
}) => (
  <div className="banner-customers">
    <div className="banner-customers__block">
      <div className="banner-customers__interview__header">
        <h2 className="banner-customers__title">
          <FormattedMessage id="home-expired/HomeExpired.tsx/1" />
        </h2>
        <p className="banner-customers__subtitle">
          <FormattedMessage id="home-expired/HomeExpired.tsx/2" />
        </p>
        <div>
          <Hyperlink
            className="button large brand"
            href="/tarifs"
            source="trial_expired"
          >
            <FormattedMessage id="home-expired/HomeExpired.tsx/3" />
          </Hyperlink>
          <br />
          {!isIcp && <Other onClick={onContact} />}
          {isIcp && (
            <div className="banner-customers__footer">
              {isContacted && !hasCalled && <Contacted onClick={onCall} />}
              {!isContacted && !hasCalled && <Uncontacted onClick={onCall} />}
              {hasCalled && <Called phoneNumber={phoneNumber} />}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);
